<div
    class="position-relative d-flex flex-column align-items-center justify-content-center avatar"
    [ngClass]="{ 'avatar-with-label': withLabel }"
    tooltip="{{ tooltip }}"
    [placement]="tooltipPlacement"
    container="body"
    [adaptivePosition]="false">
    @if (user.image) {
        @if (isDarkMode) {
            <img
                class="rounded-circle user-native-avatar"
                [alt]="'User avatar' | translate"
                [class]="userAvatarSize"
                [src]="user.image"
                onError="src = '/sb-tools/theme/images/default-avatar-white.png'" />
        } @else {
            <img
                class="rounded-circle user-native-avatar"
                [alt]="'User avatar' | translate"
                [class]="userAvatarSize"
                [src]="user.image"
                onError="src = '/sb-tools/theme/images/default-avatar.png'" />
        }
    } @else {
        <ngx-avatars
            name="{{ userLabelLetter }}"
            [round]="true"
            [size]="avatarSize"
            [initialsSize]="1"
            [textSizeRatio]="3">
        </ngx-avatars>
    }

    @if (withLabel && isTeamMember && user.role !== userRoleEnum.readOnlyUser) {
        <div
            class="avatar-label"
            [ngStyle]="{
                'background-color': userAvatarService.labelBgColor,
                color: userAvatarService.labelTextColor,
                top: avatarSize + 'px',
            }">
            {{ user.role | roleName }}
        </div>
    }
</div>
